module.exports = __webpack_public_path__ + "static/media/light_fixture_console_led.780167a9.png";